<template>
  <div>
    <!-- Details -->
    <h4 class="form-header">{{ $t('observations.details_title')}}</h4>
    <div class="row">
      <div class="col-sm-4 nopads">
        <span class="item-detail-title">{{ $t('observations.type') }}</span>
        <span class="item-detail-text">{{ observation.type.name }} ({{ observation.type.observation_group.name }})</span>
      </div>
      <div class="col-sm-4 nopads">
        <road-addess-view
          :road-number="observation.road_number"
          :section-number="observation.section_number"
          :distance="observation.distance_from_sec_start"
          :street-name="observation.street_name"
        />
      </div>
      <div class="col-sm-4 nopads">
            <span class="item-detail-title">{{ $t('observations.city') }}</span>
            <span
                v-if="observation.city"
                class="item-detail-text"
            >
          {{ observation.city.name }}
        </span>
            <span
                v-else
                class="item-detail-text"
            >
          -
        </span>
      </div>
    </div>

    <div class="row nopads">
      <div class="col-sm-12 nopads">
        <span class="item-detail-title">{{ $t('work_report.info') }}</span>
        <span class="item-detail-text">{{ observation.info ? observation.info : '-' }}</span>
      </div>
    </div>
  </div>
</template>

<script>
import {observationHelper} from '../mixins/ObservationMixin'
import MarkerEditorMap from '../map/MarkerEditorMap'
import {mapHelper} from '../mixins/MapMixin'
import {restApi} from '../mixins/RestApiMixin'
import {Pagination} from "@egjs/flicking-plugins";
import "@egjs/flicking-plugins/dist/pagination.css";
import "@egjs/vue3-flicking/dist/flicking.css";
import Flicking from "@egjs/vue3-flicking";
import ImageView from "@/components/view/ImageView.vue";
import RoadAddessView from "@/components/velho/RoadAddressView";
import { Arrow } from "@egjs/flicking-plugins"

export default {
    name: 'WorkAssignmentObservation',
    components: {RoadAddessView, MarkerEditorMap, Flicking, ImageView},
    mixins: [observationHelper, mapHelper, restApi],
    props: {
        observation: {
            type: Object,
            default: null
        }
    },
    data: function () {
        return {
            plugins: [
                new Arrow(),
                new Pagination({type: 'bullet'})
            ],
            options: {
                preventDefaultOnDrag: true,
                bound: true,
            },
        }
    },
}
</script>

<style scoped>
.map-container {
    height: 250px;
    margin-bottom: -0.2em;
}
.flicking-pagination-bullets-container {
    bottom: .5rem;
}
</style>


